var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509 509",
    style: {
      enableBackground: "new 0 0 509 509"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6EB1E1"
    },
    cx: 254.5,
    cy: 254.5,
    r: 254.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F3F7"
    },
    d: "M463.5,278.4c-0.7-7.2-5.4-13.4-12.2-16l-25.4-10c-3.8-1.5-7.1-4.2-9.3-7.7l-37-58.9 c-3.5-5.6-9.7-9.1-16.4-9.1h-59.6v141.4h164L463.5,278.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4485C5"
    },
    d: "M399.9,250l-34.7-55.2c-0.4-0.7-1.2-1.1-2-1.1h-42.6V250H399.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DEDEDF"
    },
    d: "M470.6,318h-167v37.8h167.1c4.6,0,8.3-3.7,8.3-8.3v-21.2C479,321.8,475.2,318,470.6,318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBD303"
    },
    d: "M289.6,119.2H53.7c-7.7,0-14,6.3-14,14v222.6h263.8V133.2C303.6,125.5,297.3,119.2,289.6,119.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.7,
    y: 318,
    style: {
      fill: "#DEDEDF"
    },
    width: 263.8,
    height: 37.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333842"
    },
    d: "M190.8,354.3c0-26.8-21.7-48.4-48.4-48.4S94,327.6,94,354.3c0,0.5,0.1,1,0.1,1.5h96.7 C190.8,355.3,190.8,354.8,190.8,354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333842"
    },
    d: "M388.6,305.9c-26.8,0-48.4,21.7-48.4,48.4c0,0.5,0.1,1,0.1,1.5H437c0-0.5,0.1-1,0.1-1.5 C437.1,327.6,415.4,305.9,388.6,305.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#414753"
    },
    cx: 388.6,
    cy: 354.3,
    r: 41.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#646B79"
    },
    cx: 388.6,
    cy: 354.3,
    r: 23.1
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#414753"
    },
    cx: 142.4,
    cy: 354.3,
    r: 41.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#646B79"
    },
    cx: 142.4,
    cy: 354.3,
    r: 23.1
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTruck);
export default __webpack_public_path__ + "static/media/delivery-truck.b16120f0daa49b7e74cb257abd2fe0ae.svg";
export { ForwardRef as ReactComponent };